import { Alert } from '@/components/ui/alert';
import type { AlertProps } from '@/components/ui/alert';
import * as React from 'react';

export interface PermissionNoticeProps extends Omit<AlertProps, 'status' | 'variant' | 'title'> {
  title: string;
  description: string;
}

export const PermissionNotice = React.forwardRef<HTMLDivElement, PermissionNoticeProps>(
  function PermissionNotice({ title, description, ...rest }, ref) {
    return (
      <Alert ref={ref} status="info" variant="subtle" title={title} {...rest}>
        {description}
      </Alert>
    );
  }
);
